import { AbstractPmsApiService } from "./abstract.service";
import { ThirdPartyReservationSource } from "../models";

/**
 * @class ThirdPartyReservationSourcePmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<ThirdPartyReservationSource>}
 */
export class ThirdPartyReservationSourcePmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/third-party-reservation-source(/:id)';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {ThirdPartyReservationSource}
     * @protected
     */
    newModel(attributes, ...params) {

        return new ThirdPartyReservationSource(attributes);
    }

    /**
     * @param {Object=} params
     * @param {Property=} property
     * @returns {Promise.<PaginationCollection<ThirdPartyReservationSource>>}
     */
    get (params = {}, property = null) {

        const url = this.url({propertyId: property ? property.id : 0});

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ThirdPartyReservationSource} reservationSource
     * @param {Property} property
     * @returns {Promise.<ThirdPartyReservationSource>}
     */
    create(reservationSource, property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, reservationSource.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ThirdPartyReservationSource} reservationSource
     * @returns {Promise.<ThirdPartyReservationSource>}
     */
    update(reservationSource) {

        const url = this.url({
            propertyId: reservationSource.property.id,
            id:         reservationSource.id
        });

        return this.http
            .put(url, reservationSource.toObjectExcept('property'), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {ThirdPartyReservationSource} reservationSource
     * @returns {Promise.<boolean>}
     */
    delete(reservationSource) {

        const url = this.url({
            propertyId: reservationSource.property.id,
            id:         reservationSource.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/third-party-reservation-source.service.js